const WORD_LENGTH_TO_ABBREVIATE = 7;
const LINE_LENGTH_TO_BREAK = 8;


export function abbreviate(string = '') {
    const words = string.split(/\s+/g);

    return words.map(word => {
        return (word.length > WORD_LENGTH_TO_ABBREVIATE) ? `${word.slice(0, 7)}.` : word;
    }).join(' ');
}


export function capitalize(string = '') {
    if (!string) return '';
    return `${string[0].toUpperCase()}${string.slice(1)}`;
}


export function wordBreak(string = '') {
    const charsNotToBreak = ['/', '&'];
    const words = string.split(/\s+/g);

    const wordsWithBreak = [];
    let currWordStart = 0;
    let currLineLength = words[0].length;

    for (let i = 1; i < words.length; i += 1) {
        const word = words[i];
        currLineLength += (1 + word.length); // one for the space

        // push current line
        if (currLineLength > LINE_LENGTH_TO_BREAK) {
            const line = words.slice(currWordStart, i).join(' ');
            wordsWithBreak.push(`${line}<br />`);

            currWordStart = i;
            currLineLength = word.length;
        }
    }

    // push whatever that's left
    const line = words.slice(currWordStart).join(' ');
    wordsWithBreak.push(line);

    return wordsWithBreak.join('');
}


export function pad(inputVal, inputLen) {
    let val = inputVal;
    let len = inputLen;
    val = String(val);
    len = len || 2;
    while (val.length < len) val = `0${val}`;
    return val;
}


export function rtrim(str, chars) {
    const newChars = chars || '\\s';
    return str.replace(new RegExp(`[${newChars}]+$`, 'g'), '');
}

export function urlify(text) {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, '<a href="$1" class="text-blue" target="_blank">$1</a>');
}
